import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SalesPromptDialogData {
  id?: string;
  prompt_type: 'executive_summary' | 'scope_items' | 'product_assignment';
  prompt_title: string;
  prompt_content: string;
  is_default: boolean;
}

interface SalesPromptDialogContextType {
  isOpen: boolean;
  dialogData: SalesPromptDialogData | null;
  openSalesPromptDialog: (data?: SalesPromptDialogData) => void;
  closeSalesPromptDialog: () => void;
}

const SalesPromptDialogContext = createContext<SalesPromptDialogContextType | undefined>(undefined);

interface SalesPromptDialogProviderProps {
  children: ReactNode;
}

const defaultPromptData: SalesPromptDialogData = {
  prompt_type: 'executive_summary',
  prompt_title: '',
  prompt_content: '',
  is_default: false,
};

export const SalesPromptDialogProvider = ({ children }: SalesPromptDialogProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogData, setDialogData] = useState<SalesPromptDialogData | null>(null);

  const openSalesPromptDialog = (data?: SalesPromptDialogData) => {
    setDialogData(data || defaultPromptData);
    setIsOpen(true);
  };

  const closeSalesPromptDialog = () => {
    setIsOpen(false);
    // Keep data for persistence when navigating
  };

  const value: SalesPromptDialogContextType = {
    isOpen,
    dialogData,
    openSalesPromptDialog,
    closeSalesPromptDialog,
  };

  return (
    <SalesPromptDialogContext.Provider value={value}>
      {children}
    </SalesPromptDialogContext.Provider>
  );
};

export const useSalesPromptDialog = () => {
  const context = useContext(SalesPromptDialogContext);
  if (context === undefined) {
    throw new Error('useSalesPromptDialog must be used within a SalesPromptDialogProvider');
  }
  return context;
};
